module.exports = __webpack_public_path__ + "static/img/wild2.a0baea3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wlzb/wild2.png
// module id = NZcl
// module chunks = 0